import type { Movimentacao } from '../../api/movimentacoes.js';
import { ChipStatus } from '../../componentes/ChipStatus.js';
import { familiaDaMovimentacao, rotuloDaFamilia, tomDaFamilia } from './familia.js';

/** A família da linha, escrita e com tom próprio — nunca só a cor. */
export function ChipDeFamilia({ movimentacao }: { readonly movimentacao: Movimentacao }) {
  const familia = familiaDaMovimentacao(movimentacao);

  return (
    <ChipStatus tom={tomDaFamilia(familia)} rotulo={rotuloDaFamilia(familia)} tamanho="tabela" />
  );
}
